import __var_0__ from './median.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Binomial distribution median.
*
* @module @stdlib/stats/base/dists/binomial/median
*
* @example
* var median = require( '@stdlib/stats/base/dists/binomial/median' );
*
* var v = median( 100, 0.1 );
* // returns 10
*
* v = median( 20, 0.5 );
* // returns 10
*/

// MODULES //
var median = __var_0__;


// EXPORTS //
export default median;
